import { useQuery } from 'react-query';

import { getQueryKeys } from './queryKeys';
import {
  fetchExportFieldOptions,
  fetchExportFields,
  fetchExportTypes,
} from '../requests/exportRequests';

export const useExportTypesQuery = (options = {}) =>
  useQuery(getQueryKeys.housingStockExportTypes(), fetchExportTypes, {
    initialData: [],
    ...options,
  });

export const useExportFieldsQuery = (exportTypeId, options = {}) =>
  useQuery(
    getQueryKeys.housingStockExportFields(exportTypeId),
    () => fetchExportFields(exportTypeId),
    {
      enabled: Boolean(exportTypeId),
      ...options,
    }
  );

export const useExportFieldOptionsQuery = ({ optionsUrl }, options = {}) =>
  useQuery(
    getQueryKeys.housingStockExportFieldOptions(optionsUrl),
    () => fetchExportFieldOptions(optionsUrl),
    {
      initialData: [],
      enabled: Boolean(optionsUrl),
      ...options,
    }
  );
